import Loadable from 'app/components/Loadable';
import { lazy } from 'react';


const SettingsMenu = Loadable(lazy(() => import('./NewSettingLanding')));
const AccountSettings = Loadable(lazy(() => import('./AccountSettins')));

const ProfileSettingsWeb=Loadable(lazy(() => import('./ProfileSettings')));
const settingnewoutes = [


  { path: '/setting', element: <SettingsMenu /> },
  { path: '/setting/account-settings', element: <AccountSettings /> },

  { path: '/setting/edit-profile', element: <ProfileSettingsWeb /> },





//   { path: '/setting', element: <SettingsMenu /> },
//   { path: '/setting/notification', element: <Notification /> },
//   { path: '/setting/EditExperience', element: <EditExperience /> },
//   { path: '/setting/EditEducation', element: <EditEducation /> },
//   { path: '/setting/edit-profile', element: <ProfileSettingsWeb /> },
//   { path: '/setting/edit-profile/edit-biodata', element: <Biography /> },
//   { path: '/setting/edit-profile/edit-comapny', element: <EditCompanyDetails /> },
//   { path: '/setting/edit-profile/edit-EditWhosleadingthis', element: <EditWhosleadingthis /> },
//   { path: '/setting/edit-profile/Add-industry', element: <AddIndustryDetails /> },
//   { path: '/setting/edit-profile/edit-industry', element: <EditIndustryDetails /> },
//   { path: '/setting/edit-profile/edit-project', element: <EditProjecttypes /> },
//   { path: '/setting/edit-profile/change-prefernce', element: <Preference /> },
//   { path: '/setting/account-settings', element: <AccountSetting /> },
//   { path: '/setting/account-settings/confirm-password', element: <PasswordSetting /> },
//   { path: '/setting/account-settings/change-email', element: <ChangeEmail /> },
//   { path: '/setting/account-settings/change-phonenumber', element: <ChangePhone /> },
//   { path: '/setting/account-settings/delete-account', element: <DeleteAccount /> },
//   { path: '/setting/account-settings/blocked-account', element: <BlockedAccount /> },
//   { path: '/setting/my-devices', element: <MyDevices /> },
//   { path: '/setting/edit-profile/edit-EditLanguages', element: <EditLanguages /> },
//   { path: '/setting/EditUnionAssociations', element: <EditUnionAssociations /> },
//   { path: '/setting/GHEditIndustry', element: <GHEditIndustry /> },
//   { path: '/setting/GHEditSkills', element: <GHEditSkills /> },

  
];

export default settingnewoutes;

// const ProfileSettingsWeb = Loadable(lazy(() => import('./EditProfile')));
// const Biography = Loadable(lazy(() => import('../Account/BiodataEdit')));
// const EditCompanyDetails = Loadable(lazy(() => import('../Settings/EditCompanyDetails')));
// const AddIndustryDetails = Loadable(lazy(() => import('../Settings/AddIndustryDetails')));
// const EditIndustryDetails = Loadable(lazy(() => import('../Settings/EditIndustryDetails')));
// const EditProjecttypes = Loadable(lazy(() => import('../Settings/EditProjecttypes')));
// const Preference=Loadable(lazy(()=>import('../Account/Experience')));
// const Notification=Loadable(lazy(()=>import('./Notification')));
// const AccountSetting=Loadable(lazy(()=>import('./accountSettins')));
// const PasswordSetting=Loadable(lazy(()=>import('./passwordSetting')));
// const ChangeEmail=Loadable(lazy(()=>import('./ChangeEmailSettings')));
// const ChangePhone=Loadable(lazy(()=>import('./ChangePhoneNumber')));
// const DeleteAccount=Loadable(lazy(()=>import('./DeletdAccount')));
// const BlockedAccount=Loadable(lazy(()=>import('./BlockedAccount')));
// const MyDevices=Loadable(lazy(()=>import('./DevicesLogin')));
// const EditExperience=Loadable(lazy(()=>import('./EditExperience')));
// const EditEducation=Loadable(lazy(()=>import('./EditEducation')));
// const EditWhosleadingthis = Loadable(lazy(()=>import('../Settings/Editwhosleadingthis')));
// const EditLanguages = Loadable(lazy(() => import('../Settings/EditLanguages')));

// const EditUnionAssociations = Loadable(lazy(() => import('../Settings/EditUnionAssociations')));
// const GHEditIndustry = Loadable(lazy(() => import('../Settings/GHEditIndustry')));
// const GHEditSkills = Loadable(lazy(() => import('../Settings/GHEditSkills')));